import React, { useEffect, useState } from 'react'
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input'
import { applicationStore } from 'src/store/ApplicationStore';
import logger from 'src/utils/logger';

const PhoneNumberInput = ({ setIsActive, setPhoneValue }) => {
    logger.log(applicationStore.country.toLowerCase());
    const [borderColor, setBorderColor] = useState('');
    const [value, setValue] = useState()
    const handleClickInside = () => setBorderColor('border-SorrellBrown4000');
    const handleClickOutside = (event) => {
        if (!document.getElementById('phoneField').contains(event.target)) {
            setBorderColor('border-Gray200');
        }
    };
    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    useEffect(() => {
        setPhoneValue(value)
        if (value) {
            setIsActive(isValidPhoneNumber(value));
        } else {
            setIsActive(false)
        }
    }, [value])


    return (
        <div id="phoneField" onClick={handleClickInside} className={`flex items-center w-[313px] h-[61px] border rounded-[16px] ${borderColor}`}>
            <PhoneInput
                international
                countryCallingCodeEditable={false}
                defaultCountry={applicationStore.country.toUpperCase()}
                value={value}
                onChange={setValue}
                className='h-full block p-2.5 w-full rounded-r-[16px] [outline:none]'
                numberInputProps={{
                    className: "h-full block p-2.5 w-full rounded-r-[16px] [outline:none] text-Gray900 placeholder:text-Gray400 bg-white focus:border-SorrellBrown4000"
                }}
            />
        </div>
    );



}

export default PhoneNumberInput